/**
 * Header Scroll State
 *
 * Adds .site-header--scrolled past SCROLL_THRESHOLD, removes it on
 * scroll back up. Renamed from the old --sticky naming since this
 * system no longer swaps markup on scroll (no compact/full split) --
 * it's purely a CSS-driven visual state (transparent-at-top -> solid,
 * bigger logo -> smaller) on the SAME markup. CSS handles all
 * transitions/animations; this file only tracks the boolean state.
 *
 * .site-header--on-dark (set server-side in header__default.php from
 * the hero__bg-dark field) is independent of this -- CSS is
 * responsible for deciding how the two combine (typically: on-dark
 * styling only applies while NOT scrolled, since a solid scrolled
 * header usually reverts to normal contrast regardless of hero color).
 */

(function () {
  "use strict";

  const SCROLL_THRESHOLD = 600;
  const SCROLLED_CLASS = "site-header--scrolled";

  let headers = [];
  let isScrolled = false;

  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldBeScrolled = scrollY > SCROLL_THRESHOLD;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;

      headers.forEach((header) => {
        header.classList.toggle(SCROLLED_CLASS, isScrolled);
      });
    }
  }

  function init() {
    headers = Array.from(document.querySelectorAll(".site-header"));

    if (headers.length === 0) {
      console.warn("Header scroll state: No .site-header elements found");
      return;
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
